<template>
  <div>
    <!-- hero -->
    <div class="page-wrapper pt-0 pb-0">
      <hero
        :show-sign-up="false"
        :full-screen="hero.is_full_screen"
        :title="hero.h1Array"
        :copy="hero.by_lineArray"
        :feature="hero.feature"
        :image-url="hero.image_url"
        :mobi-image-url="hero.mobi_image_url"
        :background-color="hero.background_color"
        :text-color="hero.button_color"
      />
    </div>

    <home-page-carousel :data-provider="getRecommendationFetchRequest" :title="recommendedBrandsSectionTitle" />

    <div v-if="showBrandRecommendations === false" id="features" class="pb-30 pt-10 bt bb">
      <div class="container">
        <div class="grid-12">
          <div class="span-4 span-12-sm mb-30-sm text-center px-10">
            <img src="@/assets/img/home/ribbon.svg" class="width-75px unselectable no-events" alt="ribbon-icon" />
            <h4>Premium Partners</h4>
            <p class="font-size-18 mt-10">
              We only stock the best. Shop thousands of brands vetted for quality and reliability.
            </p>
          </div>
          <div class="span-4 span-12-sm mb-30-sm text-center px-10">
            <img src="@/assets/img/home/hearts.svg" class="width-75px unselectable no-events" alt="hearts-icon" />
            <h4>Community</h4>
            <p class="font-size-18 mt-10">
              Create a custom feed of the brands you want to meet, message, and order from.
            </p>
          </div>
          <div class="span-4 span-12-sm text-center px-10">
            <img src="@/assets/img/home/calendar.svg" class="width-75px unselectable no-events" alt="calendar-icon" />
            <h4>Net 60 Payment Terms</h4>
            <p class="font-size-18 mt-10">
              Sell your inventory for two full months before paying the wholesale invoice.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- featured -->
    <div class="page-wrapper page-wrapper--grey bb pb-70 pb-30-sm pt-70 pt-30-sm pb-30-sm">
      <div class="container home-page">
        <featured :is-user-logged="true" />
      </div>
    </div>

    <home-page-carousel class="bg-green" title="Perfect for the" :data-provider="fetchMapCollectionsToCarouselItems" />

    <!-- new arrivals -->
    <div class="page-wrapper page-wrapper--white pb-130 pt-30-sm pb-30-sm">
      <div class="container home-page">
        <h4 class="mb-30">new arrivals</h4>
        <featured-brands />
      </div>
    </div>
    <!-- about -->
    <about :title="about.title" :copy="about.copy" />
    <!-- BEST SELLERS -->
    <div class="page-wrapper page-wrapper--white bt pb-130 pt-30-sm pb-90-sm">
      <div class="container home-page text-center">
        <h4 class="mb-30 text-left">BEST SELLERS</h4>
        <best-sellers :is-user-logged="false" />
      </div>
    </div>
  </div>
</template>

<script>
import Featured from "./featured/featured.vue";
import Hero from "./hero/hero.vue";
import FeaturedBrands from "./featuredBrands/featuredBrands.vue";
import BestSellers from "./bestSellers/bestSellers.vue";
import HomePageCarousel from "./homePageCarousel/homePageCarousel.vue";
import About from "./about/about.vue";
import MiscApi from "@/services/api/misc.js";

import CMSAPI from "../../services/api/contentManagmentApi";
import { recommendationsApi } from "@/services/api/recommendationsApi";
import algoliasearch from "algoliasearch/lite";
import { homePageHelper } from "../../components/mixin/homePageHelper";
const MiscApiService = new MiscApi();

const { getHero, getAbout } = new CMSAPI();
export default {
  components: {
    HomePageCarousel,
    Featured,
    FeaturedBrands,
    BestSellers,
    Hero,
    About,
  },
  mixins: [homePageHelper],
  data() {
    return {
      hero: {},
      about: {},
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      showBrandRecommendations: null,
      recommendedBrandsSectionTitle: "Perfect for you",
    };
  },
  beforeMount() {
    getHero()
      .then((response) => {
        const heroData = response.data[0];
        this.hero = {
          ...heroData,
          h1Array: heroData.h1.split("_%_").map((value) => ({
            value: value,
          })),
          by_lineArray: heroData.by_line.split("_%_").map((value) => ({
            value: value,
          })),
        };
      })
      .catch((error) =>
        error.response
          ? this.$swal("Attention", error.response.data.error_message)
          : this.$bugsnagClient.notify(new Error(error))
      );
    getAbout()
      .then((response) => {
        this.about = response.data[0];
      })
      .catch((error) =>
        error.response
          ? this.$swal("Attention", error.response.data.error_message)
          : this.$bugsnagClient.notify(new Error(error))
      );
  },
  methods: {
    getRecommendationFetchRequest: async function () {
      const user = this.$session.getUserInfo();

      if (user.role !== "RETAILER") {
        this.showBrandRecommendations = false;
        return [];
      }

      try {
        const { data: retailer } = await MiscApiService.getMeRetailer();
        const { data } = await recommendationsApi.fetchRecommendedBrands(retailer.id);
        const brandsIndex = this.$env.getOrigin() + "_brands";
        const brands = await this.algoliaClient.initIndex(brandsIndex).getObjects(data.brand_ids);

        this.recommendedBrandsSectionTitle = `Picked for ${retailer.store_name}`;
        this.showBrandRecommendations = Boolean(brands.results.length);

        return brands.results.map(({ brand_name, thumbnail_image_url, id, vanity_url_name }) => {
          return {
            title: brand_name,
            imageUrl: thumbnail_image_url,
            id,
            routerLinkTo: `/brands/${vanity_url_name}`,
            trackEventData: {
              action: "Bulletin Recommendations Click",
              properties: {
                Location: "Homepage",
                "Brand Name": brand_name,
                "Retailer Store Name": retailer.store_name,
              },
            },
          };
        });
      } catch (error) {
        this.showBrandRecommendations = false;
        return [];
      }
    },
  },
};
</script>
